.fab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  padding: 0;
  width: 56px;
  height: 56px;
  background-color: var(--tuna-palette-secondary-main);
  color: var(--tuna-palette-secondary-contrastText);
  box-shadow: var(--tuna-shadow-4);
  transition:
    background-color var(--tuna-transitions-duration-short) var(--tuna-transitions-easing-easeInOut),
    box-shadow var(--tuna-transitions-duration-short) var(--tuna-transitions-easing-easeInOut);
  -webkit-tap-highlight-color: transparent;
  z-index: var(--tuna-zIndex-fab);
}

.fab:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
}

.fab:hover {
  background-color: var(--tuna-palette-secondary-dark);
  box-shadow: var(--tuna-shadow-4);
}

.sizeSmall {
  width: 40px;
  height: 40px;
}

.sizeMedium {
  width: 48px;
  height: 48px;
}

.extended {
  border-radius: var(--tuna-shape-radius-pill);
  width: auto;
  padding: 0 16px;
  min-width: 48px;
  min-height: 48px;
}

.colorPrimary {
  background-color: var(--tuna-palette-primary-main);
  color: var(--tuna-palette-primary-contrastText);
}
.colorPrimary:hover {
  background-color: var(--tuna-palette-primary-dark);
}
